import { render, staticRenderFns } from "./CookieNotification.vue?vue&type=template&id=d10dc86a&"
import script from "./CookieNotification.vue?vue&type=script&lang=js&"
export * from "./CookieNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports